// layout/MainLayout.styles.js
import { DRAWER_WIDTH } from "../../routes/constants.js";

const DRAWER_WIDTH_COLLAPSED = 64;
const drawerWidth = (isMobile, collapsed) => {
  if (isMobile) return 0;
  return collapsed ? DRAWER_WIDTH_COLLAPSED : DRAWER_WIDTH;
};
const drawerPaperWidth = (isMobile, collapsed) => {
  if (isMobile) return DRAWER_WIDTH;
  return collapsed ? DRAWER_WIDTH_COLLAPSED : DRAWER_WIDTH;
};

const contentWidth = (collapsed, isMobile) => {
  if (isMobile) return "calc(100% - 0px)";
  const width = collapsed ? DRAWER_WIDTH_COLLAPSED : DRAWER_WIDTH;
  return `calc(100% - ${width}px)`;
};
const styles = {
  root: (collapsed, isMobile) => ({
    width: "100%",
    display: "flex",
    minHeight: "100vh",
    boxSizing: "border-box",
    bgcolor: "background.default",
    margin: 0,
    padding: 0,
    position: "relative",
  }),

  nav: (collapsed, isMobile) => ({
    width: drawerWidth(isMobile, collapsed),
    flexShrink: 0,
    transition: (theme) =>
      theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
  }),

  drawerPaper: (collapsed, isMobile) => ({
    width: drawerPaperWidth(isMobile, collapsed),
    bgcolor: "background.default",
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    position: "relative",
    overflowX: "visible",
    zIndex: 1200,
    transition: (theme) =>
      theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
  }),

  drawerContent: (collapsed) => ({
    height: "100%",
    display: "flex",
    flexDirection: "column",
    position: "relative",
    overflowX: "hidden",
  }),

  logoContainer: (collapsed) => ({
    px: collapsed ? 1 : 2,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    transition: (theme) =>
      theme.transitions.create(["padding"], {
        duration: theme.transitions.duration.shorter,
      }),
  }),

  logo: (collapsed) => ({
    mt: 5,
    mb: 5,
    height: 68,
    width: "100%",
    transition: (theme) =>
      theme.transitions.create(["height"], {
        duration: theme.transitions.duration.shorter,
      }),
  }),

  navList: {
    flexGrow: 1,
  },

  navButton: (collapsed) => ({
    justifyContent: collapsed ? "center" : "flex-start",
    px: collapsed ? 1 : 2,

    "&.Mui-selected": {
      backgroundColor: "buttons.main",
      ".MuiListItemText-primary": {
        fontWeight: 500,
      },
      "&:hover": {
        backgroundColor: "buttons.main",
        color: "text.greyed",
      },
    },
    ...(collapsed
      ? {}
      : {
          ".MuiListItemText-primary": {
            fontSize: "1.125rem",
            fontWeight: 400,
            color: "text.main",
          },
        }),
  }),

  navIcon: (collapsed) => ({
    minWidth: collapsed ? 0 : 56,
    justifyContent: "center",
    fontSize: "1.5rem",
  }),

  bottomActions: (collapsed) => ({
    mt: "auto",
    borderTop: "1px solid",
    borderColor: "divider",
    display: "flex",
    flexDirection: collapsed ? "column" : "row",
    alignItems: "center",
    justifyContent: collapsed ? "center" : "space-between",
    p: 1,
    gap: collapsed ? 1 : 0,
  }),

  userInfo: (collapsed) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: collapsed ? "center" : "flex-start",
    cursor: "pointer",
    minHeight: 48,
    // px: collapsed ? 0 : 2,
    py: 0, // no extra vertical padding
    width: "100%",
    boxSizing: "border-box",
  }),

  avatar: {
    width: 32,
    height: 32,
    fontSize: 14,
  },

  userName: {
    fontWeight: 500,
    color: "text.primary",
    maxWidth: 120,
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    // ml will be applied conditionally
  },
  actionButton: (collapsed) => ({
    justifyContent: collapsed ? "center" : "flex-start",
    flexShrink: 0,
  }),

  versionBox: {
    p: 2,
  },

  versionText: {
    color: "text.secondary",
  },
  drawerWrapper: (collapsed, isMobile, isRtl) => {
    let width;
    if (isMobile) {
      width = 0;
    } else {
      width = collapsed ? DRAWER_WIDTH_COLLAPSED : DRAWER_WIDTH;
    }
    
    return {
      position: "relative",
      width,
      // Important: in RTL, the drawer is on the right, so  float it
      ...(isRtl &&
        !isMobile && {
          ml: "auto",
        }),
    };
  },

  collapseButtonOverlay: (collapsed, isRtl) => {
    const expandedWidth = DRAWER_WIDTH; // e.g., 260
    const collapsedWidth = DRAWER_WIDTH_COLLAPSED; // e.g., 64

    return {
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      zIndex: 1300,
      width: 30,
      height: 30,
      bgcolor: "grey.300",
      border: "1px solid",
      borderColor: "divider",
      borderRadius: "50%",
      "&:hover": {
        bgcolor: "grey.300",
      },
      transition: (theme) =>
        theme.transitions.create(["left", "right"], {
          duration: theme.transitions.duration.shorter,
        }),

      ...(isRtl
        ? {
            left: collapsed ? collapsedWidth - 20 : expandedWidth - 20,
          }
        : {
            right: -20,
          }),
    };
  },

  content: (collapsed, isMobile) => ({
    flexGrow: 1,
    width: contentWidth(collapsed, isMobile),
    minWidth: 0,
    p: { xs: 2, md: 3 },
    boxSizing: "border-box",
    bgcolor: "background.paper",
    transition: (theme) =>
      theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
  }),

  sideBarWrapper: () => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    flexGrow: 1,
    height: "100%",
  }),
};

export default styles;
